'use strict'
setTimeout(() => {

    // LOADER WAITLIST
    
    const container = document.querySelector(".container");
    const swiper = document.querySelector(".swiper-container");
    const cta = document.querySelector(".cta");
    const footer = document.querySelector(".footer");

    container.style.display = "block";
    swiper.style.display = "block";
    cta.style.display = "flex";
    footer.style.display = "block";

    //PARALLAX

    gsap.registerPlugin(ScrollTrigger);


    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: "#hero",
            start: "top top",
            end: "bottom top",
            scrub: true
        }
    });

    gsap.utils.toArray(".parallax").forEach(layer => {
    
        const depth = layer.dataset.depth;
        const movement = -(layer.offsetHeight * depth)

        tl.to(layer,
        {y: movement,
        ease: "none"}
    , 0)

    });

}, 2200);

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// swiper


var swiperOptions = {
    direction: 'horizontal',
    slidesPerView: 3,
    spaceBetween: 100,
    mousewheel: {
      invert: false,
      eventsTarget: '.swiper',
      direction: "horizontal",
      forceToAxis: true,
    },
    centeredSlides: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
  };
  
  // Check the number of slides
  var slideCount = document.querySelectorAll(".swiper-slide").length;
  if (slideCount < 9) {
    swiperOptions.loop = false;
  }
  
  // Adjust slides per view for viewport width
  if (window.innerWidth <= 768) {
    swiperOptions.slidesPerView = 1;
  }
  
  var swiper = new Swiper(".mySwiper", swiperOptions);






//parallax video


const parallax = document.getElementById("parallax");

// Parallax Effect for DIV 1
window.addEventListener("scroll", function () {
  let offset = window.pageYOffset;
  parallax.style.backgroundPositionY = offset * 0.7 + "px";
  // DIV 1 background will move slower than other elements on scroll.
});










//REVEAL CONTENT SCROLL

window.addEventListener('scroll', reveal);

function reveal(){
    var reveals = document.querySelectorAll('.reveal')

    for(var i = 0; i < reveals.length; i++){
        var windowHeight = window.innerHeight;
        var revealTop = reveals[i].getBoundingClientRect().top;
        var revealPoint = 150;

        if(revealTop < windowHeight - revealPoint){
            reveals[i].classList.add('active');
        }
        else{
            reveals[i].classList.remove('active');
        }
    }
}
// FOOTER DATE 

var d = new Date();
var n = d.getFullYear();
document.querySelector(".year").innerHTML = n;
  